// description            --  Условия задачи
// schema                 --  Схема данных
//   --schemaDiagram      --  ER-диаграмма
//   --schemaDescription  --  Описание
// editor                 --  Редактор кода
// solution               --  Решение
//   --masterSolution     --  Эталонное решение
//   --mySolution         --  Мое решение
// masterResult           --  Эталонный результат
// myResult               --  Мой результат
//  Из дровера
// theory                 --  Теория
// taskList               --  Список уроков
//  Еще нет
// ddlResult              --  Результат
// queryResults           --  Запросы
// editorSetting          --  Настройки редактора

export enum ComponentEnum {
  description = 'description',
  schema = 'schema',
  schemaDiagram = 'schemaDiagram',
  schemaDescription = 'schemaDescription',
  editor = 'editor',
  solution = 'solution',
  masterSolution = 'masterSolution',
  mySolution = 'mySolution',
  masterResult = 'masterResult',
  myResult = 'myResult',
  theory = 'theory',
  taskList = 'taskList',
  ddlResult = 'ddlResult',
  queryResults = 'queryResults',
  editorSetting = 'editorSetting',
}

export enum ComponentNameEnum {
  description = 'Условия задачи',
  schema = 'Схема данных',
  schemaDiagram = 'ER-диаграмма',
  schemaDescription = 'Описание',
  editor = 'Редактор кода',
  solution = 'Решение',
  masterSolution = 'Эталонное решение',
  mySolution = 'Мое решение',
  masterResult = 'Эталонный результат',
  myResult = 'Мой результат',
  theory = 'Теория',
  taskList = 'Список уроков',
  ddlResult = 'Результат',
  queryResults = 'Запросы',
  editorSetting = 'Настройки редактора',
}
